import { CallCalling, Facebook, Sms } from 'iconsax-react';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SectionLayout from '../../layouts/SectionLayout';
import { scrollToTop } from '../../utils/Index';
import { Linkedin } from 'lucide-react';
import { FaInstagram, FaTiktok, FaTwitter, FaYoutube } from 'react-icons/fa';
const socialLinks = [
  {
    href: 'https://www.facebook.com/jompstart',
    icon: <Facebook size={20} color="#FFFFFF" />,
  },
  {
    href: 'https://www.linkedin.com/company/jompstart',
    icon: <Linkedin size={20} color="#FFFFFF" />,
  },
  {
    href: 'https://www.x.com/jompstart',
    icon: <FaTwitter size={20} color="#FFFFFF" />,
  },
  {
    href: 'https://www.instagram.com/jompstart',
    icon: <FaInstagram size={20} color="#FFFFFF" />,
  },
  {
    href: 'https://www.tiktok.com/@jompstart',
    icon: <FaTiktok size={20} color="#FFFFFF" />,
  },
  {
    href: 'https://www.youtube.com/@jompstart',
    icon: <FaYoutube size={20} color="#FFFFFF" />,
  },
];
const quickLinks = [
  { label: 'Home', path: '/' },
  { label: 'Contact us', path: '/contact' },
  { label: 'Terms and Conditions', path: '/terms&conditions' },
  { label: 'Privacy Notice', path: '/privacy' },
];
const Footer: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const text: string = `We make it easy to Find and Pay for Life’s Essential Service. We offer flexible payment plans for services like auto care, medical bills and home repairs. With transparent terms, quick approval, and a user-friendly platform, JompStart is promoting financial wellness and stability for those who need it the most.
  All financial services on JompStart, including Payment & Lending are powered by our licensed Payment & Banking Partners in respective countries
`;
  const toggleReadMore = () => setIsExpanded(!isExpanded);

  // Define the shortened text length
  const shortTextLength = 30;
  const shortText = text.substring(0, shortTextLength) + '...';

  return (
    <nav className="bg-BrandSecondary py-4 md:border-t border-[#612e8d]">
      <SectionLayout>
        <div className=" mt-5">
          <div className="text-center md:px-0 lg:px-0 lg:flex md:text-left justify-between">
            <div className="logo md:w-full lg:w-2/6  mb-5 text-center md:text-left">
              <img
                src="./Assets/Jompstartwhitelogo.svg"
                alt="logo"
                className="pb-[20px]"
              />
              <div className="flex justify-center md:justify-start gap-2 pt-2">
                {socialLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.href}
                    target="_blank"
                    rel="noreferrer"
                    className="cursor-pointer rounded-full flex justify-center items-center h-[40px] w-[40px] md:h-[35px] md:w-[35px] bg-[#462071]"
                  >
                    {link.icon}
                  </a>
                ))}
              </div>
              <div className="text-container my-4 p-4  rounded shadow-sm">
                <p className="text-content text-white">
                  {isExpanded ? text : shortText}
                </p>
                <button
                  className="read-more-btn mt-2 text-BrandPrimary hover:underline"
                  onClick={toggleReadMore}
                >
                  {isExpanded ? 'Read Less' : 'Read More'}
                </button>

                <a
                  href="https://play.google.com/store/apps/details?id=com.jomp.jompstart"
                  className="flex items-center gap-2 mt-4 no-underline hover:no-underline  cursor-pointer w-fit text-white p-2 px-5 rounded border border-[#424c5d] shadow hover:shadow-lg hover:border-BrandPrimary"
                >
                  <img
                    src="/icon/play_btn2.png"
                    alt="logo"
                    className="size-10"
                  />
                  <div className="text-center">
                    <span className=" text-sm text-BrandGray600 uppercase">
                      Get it on
                    </span>
                    <p className="capitalize text-lg leading-5 font-semibold">
                      Google play
                    </p>
                  </div>
                </a>
              </div>
            </div>

            <div className="text-[14px] md:text-[18px] flex flex-col md:flex-row justify-between xl:items-start  gap-6 md:gap-40">
              <div className="text-[14px] md:text-[18px] text-white text-base flex flex-col gap-3">
                <p className="font-semibold text-[18px]">Service Links</p>
                <span className="hover:text-BrandPrimary cursor-pointer">
                  <Link to="/school-fees" onClick={scrollToTop}>
                    School Fees
                  </Link>
                </span>
                <span className="hover:text-BrandPrimary cursor-pointer">
                  <Link to="/rent" onClick={scrollToTop}>
                    House Rent
                  </Link>
                </span>
                <span className="hover:text-BrandPrimary cursor-pointer">
                  <Link to="/transportation" onClick={scrollToTop}>
                    Transport Credit
                  </Link>
                </span>
              </div>

              {/* quicklinks  */}
              <div className="text-white flex flex-col gap-[10px] md:gap-[20px]">
                <p className="font-semibold text-[18px]">Quick Links</p>
                <div className="flex flex-col gap-2">
                  {quickLinks.map((link, index) => (
                    <Link
                      key={index}
                      to={link.path}
                      onClick={scrollToTop}
                      className="cursor-pointer "
                    >
                      {link.label}
                    </Link>
                  ))}
                </div>
              </div>

              {/* contact us  */}
              <div className="text-[14px] md:text-[18px] text-white flex flex-col gap-[10px] md:gap-[20px]">
                <p className="font-semibold text-[18px]">Contact Us</p>
                <p className="text-xs text-BrandGray">Contact us at</p>
                <div className="flex gap-4 lg:items-center justify-center  ">
                  <span className="rounded-full flex justify-center items-center h-[40px] w-[40px] md:h-[45px] md:w-[45px] bg-[rgb(70,32,113)]">
                    <CallCalling size="20" color="#Ffffff" />
                  </span>
                  <p className="flex flex-col">
                    <span>+234 813 130 1273</span>
                  </p>
                </div>
                <div className="flex gap-4 lg:items-center justify-center">
                  <span className="rounded-full flex justify-center items-center h-[40px] w-[40px] md:h-[45px] md:w-[45px] bg-[#462071]">
                    <Sms size="20" color="#Ffffff" />
                  </span>
                  <div className="text-start flex flex-col">
                    <span className="flex flex-col ">
                      <a href="mailto:hello@jompstart.com">
                        hello@jompstart.com
                      </a>
                      <a href="mailto:support@jompstart.com">
                        support@jompstart.com
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <p className="text-sm text-white xl:text-left mt-4 text-center leading-loose">
            JompStart is a Service Aggregation Platform (Marketplace) for both
            service providers and users of these services. We make it easy for
            our users to find and pay for Life’s Essential Services. We are a
            technology company and we are not a bank. All payments, banking and
            financial services on the platform are powered by our licensed
            partners in their respective countries. These include but not
            limited to Stripe Inc. in the US, Paystack Payments Limited (a
            Stripe Company in Africa) and Bankly Microfinance Bank Limited, a
            CBN-licensed Microfinance Bank, amongst others. Thank you for using
            and trusting our services, delivered with care in collaboration with
            our global partners
          </p>

          <div className="flex justify-between items-center mt-14">
            <p className="text-white text-center text-[14px] md:text[16px] ">
              Copyright &copy; {new Date().getFullYear()} All Rights Reserved
            </p>
            <div className="flex gap-4 items-center">
              <Link className="text-sm text-BrandGray" to="/terms&conditions">
                Terms & Condition
              </Link>
              <Link className="text-sm text-BrandGray" to="/privacy">
                Privacy Notice
              </Link>
            </div>
          </div>
        </div>
      </SectionLayout>
    </nav>
  );
};

export default Footer;
